import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import SiteLayout from "./components/SiteLayout";
import PageMeta from "./components/PageMeta";
import { LanguageProvider } from "./i18n/LanguageContext";
import Home from "./pages/home";
import Gateway from "./pages/Gateway";
import Film from "./pages/Film";
import Tyot from "./pages/Tyot";
import Palvelut from "./pages/Palvelut";
import Yhteys from "./pages/Yhteys";

// Sivunvaihto: vanha sivu häipyy pois (fade out), uusi häipyy sisään
// (fade in). Osiot nousevat lisäksi näkyviin scroll-reveal-animaatiolla.
const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const AnimatedRoutes = () => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [stage, setStage] = useState("idle"); // idle | out | in

  useEffect(() => {
    if (location.pathname === displayLocation.pathname) return;
    if (prefersReducedMotion()) {
      setDisplayLocation(location);
      window.scrollTo(0, 0);
      return;
    }
    setStage("out");
  }, [location, displayLocation]);

  const handleFadeEnd = (e) => {
    // Lapsielementtien animaatiot (esim. portin valopallot) kuplivat tänne —
    // reagoidaan vain wrapperin omaan animaatioon.
    if (e.target !== e.currentTarget) return;
    if (stage === "out") {
      // Vanha sivu on häipynyt — vaihdetaan sivu ja häivytetään uusi sisään.
      setDisplayLocation(location);
      window.scrollTo(0, 0);
      setStage("in");
    } else if (stage === "in") {
      setStage("idle");
    }
  };

  // Sisääntulo: osiot häipyvät ja nousevat näkyviin, kun ne tulevat
  // viewporttiin (ensilatauksessa ja jokaisen sivunvaihdon jälkeen).
  useEffect(() => {
    if (prefersReducedMotion()) return;
    const els = document.querySelectorAll(
      ".page__header, .block, .teaser, .page__cta, .film__photo-wide, .cta-band, .services__item"
    );
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-inview");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => {
      el.classList.add("anim-reveal");
      io.observe(el);
    });
    return () => io.disconnect();
  }, [displayLocation]);

  return (
    <SiteLayout>
      <div
        className={`page-fade${stage !== "idle" ? ` page-fade--${stage}` : ""}`}
        onAnimationEnd={handleFadeEnd}
      >
        <Routes location={displayLocation}>
          <Route path="/" element={<Gateway />} />
          <Route path="/hetki" element={<Home />} />
          <Route path="/film" element={<Film />} />
          <Route path="/tyot" element={<Tyot />} />
          {/* Lyhyt linkki myyntiviesteihin: vie Töiden Slush-toteutukseen (Sun Effects). */}
          <Route path="/slush" element={<Navigate to="/tyot#case-sun-effects" replace />} />
          <Route path="/palvelut" element={<Palvelut />} />
          <Route path="/yhteys" element={<Yhteys />} />
          <Route path="*" element={<Gateway />} />
        </Routes>
      </div>
    </SiteLayout>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <PageMeta />
        <AnimatedRoutes />
      </Router>
    </LanguageProvider>
  );
}

export default App;
